interface CustomFormElement extends HTMLFormElement {
  _image_src: HTMLInputElement
}

export default (): void => {
  const initialiseQuickAdd = (): void => {
    document.addEventListener('submit', async (event: Event): Promise<void> => {
      event.stopImmediatePropagation();

      const target = event.target as CustomFormElement;
      const { _image_src: imageSrc }: { _image_src: HTMLInputElement } = target;
      let featuredImage: string | null = null;

      const { wishlistId } = target.dataset;

      if (!target.hasAttribute('data-quick-add')) return;

      event.preventDefault();
      const button: HTMLButtonElement = target.querySelector('[type="submit"]');

      const btnHtml = button.innerHTML;
      button.innerHTML = theme.icons.loader;

      await fetch(`${target.action}.js`, {
        method: target.method,
        body: new FormData(target),
      });

      if ((imageSrc instanceof HTMLInputElement)) {
        featuredImage = imageSrc.value;
      }

      const evt: CustomEvent<{ image: string | null; }> = new CustomEvent('cart:product:added', {
        detail: {
          image: featuredImage,
        },
      });

      button.innerHTML = theme.icons.checkmark;

      setTimeout(() => {
        button.innerHTML = btnHtml;
      }, 2000);

      if (wishlistId) {
        await WishlistKing.toolkit.removeItem(wishlistId);
        document.dispatchEvent(new Event('wishlist:update'));
      }

      document.dispatchEvent(evt);
    });
  };

  initialiseQuickAdd();
  document.addEventListener('app:remount', initialiseQuickAdd);
};
